module.exports = __webpack_public_path__ + "static/media/hair (54).ed9d7edb.jpg";